import { GridCell } from "@progress/kendo-react-grid";
import React from "react";

export default class ValidateNumberCell extends GridCell {
  constructor(props) {
    super(props);
  }

  render() {
    const { dataItem, field } = this.props;
    const dataValue = dataItem[field] === null || dataItem[field] === undefined ? "" : dataItem[field];

    // Apply styling to a span inside the cell instead of the cell itself
    const isHighlighted = dataItem.isClosedExcelUpdate === true;

    let spanStyle = isHighlighted ? {
      display: "inline-block",
      width: "196px",
      backgroundColor: "#428fed",
      fontWeight: "bold",
      fontSize: "12px",
      padding: "2px 4px",
      borderRadius: "2px"
    } : {};
    if (
      dataItem.updatedColumnsFromExcel &&
      dataItem.updatedColumnsFromExcel.includes(field)
    ) {
      spanStyle = {
        display: "inline-block",
        width: "196px",
        backgroundColor: "#034f0e",
        fontWeight: "bold",
        fontSize: "12px",
        padding: "2px 4px",
        borderRadius: "2px"
      }
    } else if (
      dataItem.nonUpdatedColumnsFromExcel &&
      dataItem.nonUpdatedColumnsFromExcel.includes(field)
    ) {
      spanStyle = {
        display: "inline-block",
        width: "196px",
        backgroundColor: "#ea8211e3",
        fontWeight: "bold",
        fontSize: "12px",
        padding: "2px 4px",
        borderRadius: "2px"
      }
    }

    return (
      <td
        className="k-grid-content-sticky"
        style={{ left: '0px', right: "0px" }}
        title={dataValue}
      >
        <span style={spanStyle}>{dataValue}</span>
      </td>
    );
  }
}